import { put, takeLatest } from "redux-saga/effects";
import { httpGet, httpPost } from "../../services";
import {
  getSigningKeysRequest,
  getSigningKeysSuccess,
  getSigningKeysError,
  rotateSigningKeyRequest,
  rotateSigningKeySuccess,
  rotateSigningKeyError,
  rotateNRevokeSigningKeyRequest,
  rotateNRevokeSigningKeySuccess,
  rotateNRevokeSigningKeyError
} from "../features/settings/signingKeys";

function* getSigningKeysHandler() {
  try {
    const response: any = yield httpGet("/platform-configuration/signing-keys");
    if (response && !response.ErrorCode) {
      // Fingerprint/Thumbprint are computed server-side and already present on each token.
      const activeTokens = (response.Tokens || []).map((t: any) => ({ ...t, status: "in-use" }));
      const nextTokens = (response.NextTokens || []).map((t: any) => ({ ...t, status: "next" }));
      const previousTokens = (response.PreviousTokens || []).map((t: any) => ({ ...t, status: "previous" }));
      const allKeys = [...activeTokens, ...nextTokens, ...previousTokens];

      const normalizedRevoked = (response.RevokedTokens || []).map((t: any) => ({
        ...t,
        ExpireAt: t.RotateAt || t.StartAt || ""
      }));

      const sortedRevoked = [...normalizedRevoked]
        .sort((a, b) => {
          const timeA = a.ExpireAt ? new Date(a.ExpireAt).getTime() : 0;
          const timeB = b.ExpireAt ? new Date(b.ExpireAt).getTime() : 0;
          return timeB - timeA;
        })
        .slice(0, 3);

      yield put(getSigningKeysSuccess({ keys: allKeys, revokedKeys: sortedRevoked }));
    } else if (response && response.ErrorCode) {
      throw new Error(response.Description || "Failed to fetch signing keys.");
    }
  } catch (e: any) {
    yield put(getSigningKeysError(e.message || "An error occurred while fetching signing keys."));
  }
}

function* rotateSigningKeyHandler() {
  try {
    const response: any = yield httpPost("/platform-configuration/signing-keys/rotate", {});
    if (response && !response.ErrorCode) {
      yield put(rotateSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to rotate signing keys");
    }
  } catch (e: any) {
    yield put(rotateSigningKeyError(e.message || "An error occurred while rotating signing keys"));
  }
}

function* rotateNRevokeSigningKeyHandler() {
  try {
    const response: any = yield httpPost("/platform-configuration/signing-keys/revoke", {});
    if (response && !response.ErrorCode) {
      yield put(rotateNRevokeSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to rotate and revoke signing keys");
    }
  } catch (e: any) {
    yield put(rotateNRevokeSigningKeyError(e.message || "An error occurred while rotating and revoking signing keys."));
  }
}

export function* watchSigningKeys() {
  yield takeLatest(getSigningKeysRequest.type, getSigningKeysHandler);
  yield takeLatest(rotateSigningKeyRequest.type, rotateSigningKeyHandler);
  yield takeLatest(rotateNRevokeSigningKeyRequest.type, rotateNRevokeSigningKeyHandler);
}
